import './scss/Equipment.scss';
import pan from './media/pan.png';
import pot from './media/pot.png';
import mortar from './media/mortar.png';

function Equipment() {

  return (
    <section id="equipment">
      <h2 className="section-header">Equipment</h2>
      <div className="section-content">
        <div className="item">
            <img className="item-image" src={pan} />
            <div className="item-description">Sauce pan</div>
        </div>
        <div className="item">
            <img className="item-image" src={pot} />
            <div className="item-description">Medium pot</div>
        </div>
        <div className="item">
            <img className="item-image" src={mortar} />
            <div className="item-description">Mortar & pestle (optional)</div>
        </div>
      </div>
    </section>
  );
}

export default Equipment;